<template>
  <div class="bg-white rounded relative"
    @dragover.prevent
    @dragenter.prevent="dragEnter($event)">

    <form @submit.prevent="updateNote()">
      <div class="p-4 bg-alt-white rounded flex border-b border-grey-light">
        <div class="flex items-center">
          <upload-file class="mr-4" @uploaded="appendLink" @error="handleUploadError" :isActive="isDropping" @donedrop="() => isDropping = false" />

        </div>
      </div>

      <div class="flex flex-wrap mb-2">
        <div class="w-full">
          <div class="">
            <div ref="note"></div>
          </div>
        </div>
      </div>
      <p v-if="error" class="text-red-dark py-4 mx-5">{{error}}</p>
      <div class="flex justify-between items-center px-5 border-t border-grey-light bg-alt-white rounded py-2">

        <!-- <div class="">
             <label class="mr-2 text-sm">Public</label>
             <input type="checkbox" v-model="isPublicField" />
             </div> -->
        <form @submit.prevent="()=>{}">
          <button
            @click="deleteNote()"
            href="#"
          >
            <font-awesome-icon size="lg" class="text-gray-dark" icon="trash" /><span class="sr-only">Delete Note</span>
          </button>
        </form>


        <div class="flex items-center">
          <div class="cursor-pointer mr-4" @click="cancelEdit">
            Cancel
          </div>
          <t-button
            type="submit"
          >Save</t-button>
        </div>
      </div>
      
    </form>
  </div>
</template>


<script>
 import {mapState, mapActions} from 'vuex';
 import UploadFile from '@/components/UploadFile'
 import editorFactory from '@/editorFactory'
 import { DateTime } from 'luxon';

 import eventBus from '@/eventBus';

 export default {
   props: {
     date: {
       type: String,
       required: true
     },
     text: {
       type: String,
       required: true
     },
     id: {
       type: String,
       required: true
     },
     isPublic: {
       type: Boolean,
       default: false
     }
   },

   data () {
     return {
       editText: this.text,
       inputDate: DateTime.fromISO(this.date)
                          .toFormat('LL/dd/yyyy HH:mm'),
       error: '',
       rerender: false,
       noteLen: this.text.length,
       isDropping: false,
       isPublicField: this.isPublic
     }
   },

   components: { UploadFile },

   mounted () {
     this.mountCM();
   },

   updated () {
     // NOTE basically this is the only point we can guarantee that the note ref is in the DOM
     // rerender is a optimization so that we're not rerendering this on every update to date etc
     if (this.rerender) {
       this.$nextTick(() => {
         this.mountCM();
       })
     }
   },

   computed: {
     displayEditDate () {
       const date = DateTime.fromFormat(this.inputDate, 'LL/dd/yyyy HH:mm')

       if (date.invalid) {
         return ' '
       }

       return date.toLocaleString(DateTime.DATETIME_FULL);
     }
   },

   methods: {
     ...mapActions(['updateRecord', 'deleteRecord']),

     appendLink (link) {
       let newNote = `${this.cm.state.doc.toString()}

${link}`

       this.cm.dispatch({
         changes: {from: 0, to: this.cm.state.doc.length, insert: newNote}
       })
     },

     handleUploadError (err) {
       this.error = err
     },

     dragEnter () {
       this.isDropping = true
     },

     async mountCM () {
       const vm = this
       const keys = [
         {
           key: 'Ctrl-Enter',
           run(view) {
             vm.updateNote()
           },
           preventDefault: true
         },
         {
           key: 'Cmd-Enter',
           run(view) {
             vm.updateNote()
           },
           preventDefault: true
         }
       ]


       this.cm = await editorFactory({
         elm: this.$refs.note,
         text: this.text,
         onChange: (txt) => { // this also fires immediately...
           this.noteLen = txt.length

           if (this.noteLen > 4800) {
             this.error = `Note is too long. Notes can't be longer than 4800 characters. This one is ${this.noteLen}.`
           } else {
             this.error = ``
           }
         },
         onSubmit: this.updateNote
       })

       /* TODO: what is this for?? specialChars: /[\uffff]/, */

       this.cm.focus();
       this.cm.dispatch({selection: {anchor: this.text.length}})

       this.inputDate = DateTime.fromISO(this.date)
                                .toFormat('LL/dd/yyyy HH:mm');

       this.error = '';

       this.rerender = false;
     },

     async updateNote () {
       const date = DateTime.fromFormat(this.inputDate, 'LL/dd/yyyy HH:mm')

       const note = this.cm.state.doc.toString()

       if (date.invalid) {
         this.error = 'Please enter a valid date';
         return;
       } else if (note.length > 4800) {
         const len = note.length
         this.error = `Note is too long. Notes can't be longer than 4800 characters. This one is ${len}.`
         return
       }

       const res = await this.updateRecord({
         id: this.id,
         text: note,
         date: date.setZone('GMT'),
         isPublic: this.isPublicField
       });

       eventBus.$emit('record');

       if (res && res.err) {
         this.error = res.err;
         return;
       }

       this.$emit('cancel')
     },

     cancelEdit () {
       this.$emit('cancel')
     },

     async deleteNote () {
       if(confirm('Are you sure you want to delete this note?')) {
         await this.deleteRecord({id: this.id});
         eventBus.$emit('record');
       }
     },
   },

 }

</script>
